import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useTrailingSlashRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;
    
    if (pathname === '/') {
      return;
    }

    if (pathname.match(/\.[a-zA-Z]+$/)) {
      return;
    }

    if (pathname.endsWith('/') && pathname.length > 1) {
      const normalizedPath = pathname.slice(0, -1);
      const newUrl = normalizedPath + search + hash;
      
      navigate(newUrl, { replace: true });
    }
  }, [location, navigate]);
};

export default useTrailingSlashRedirect;

